import "./Skills.css"

export default function Skills() {
  return <section className="skills">
    <h3 className="skills-head">SKILLS</h3>
    <h5 className="head-5" >HTML/CSS | SASS | Bootstrap | Javascript | jQuery | Ajax | React | Node JS |
   <hr />
     Express | Ruby on Rails | Postgresql | Unit Testing | Git version control </h5>
    <hr />
    <h5  className="head-5"><strong>Spoken Languages</strong>: English, Hindi, Telugu</h5>
  </section>
}

// style={{ fontFamily: "'Oxygen', sans-serif",fontSize: '25px'}}